/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Assessment_Partially_AssessedInputs */

const en_directory_agent_readiness_assessment_partially_assessed = /** @type {(inputs: Directory_Agent_Readiness_Assessment_Partially_AssessedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partially assessed`)
};

const zh_directory_agent_readiness_assessment_partially_assessed = /** @type {(inputs: Directory_Agent_Readiness_Assessment_Partially_AssessedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部分完成评测`)
};

/**
* | output |
* | --- |
* | "Partially assessed" |
*
* @param {Directory_Agent_Readiness_Assessment_Partially_AssessedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_assessment_partially_assessed = /** @type {((inputs?: Directory_Agent_Readiness_Assessment_Partially_AssessedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Assessment_Partially_AssessedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_assessment_partially_assessed(inputs)
	return zh_directory_agent_readiness_assessment_partially_assessed(inputs)
});
export { directory_agent_readiness_assessment_partially_assessed as "directory.agent_readiness.assessment.partially_assessed" }